function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useState } from "react";
import { Body, Button, ErrorMessage, Heading } from "../../atoms";
import { Section, SectionHeader } from "../../molecules";
import { GenericForm } from "../GenericForm";
import { ArrowRight } from "../../icons";
function CollapsibleSection(param) {
    var title = param.title, description = param.description, collapsible = param.collapsible, defaultExpanded = param.defaultExpanded, children = param.children;
    var ref = _slicedToArray(useState(defaultExpanded !== null && defaultExpanded !== void 0 ? defaultExpanded : !collapsible), 2), expanded = ref[0], setExpanded = ref[1];
    var header = collapsible ? /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: function() {
            return setExpanded(!expanded);
        },
        className: "w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-fg-default/5 transition-colors"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "h4"
    }, title), !!description && !expanded && /*#__PURE__*/ React.createElement(Body, {
        variant: "small",
        className: "mt-1 opacity-60"
    }, description)), /*#__PURE__*/ React.createElement("span", {
        className: "text-fg-default transition-transform duration-200 ".concat(expanded ? "rotate-180" : "")
    }, "▾")) : /*#__PURE__*/ React.createElement("div", {
        className: "w-full flex items-center justify-between px-5 py-4"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "h4"
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        variant: "small",
        className: "mt-1 opacity-60"
    }, description)));
    return /*#__PURE__*/ React.createElement("div", {
        className: "border border-fg-default/10 rounded-lg overflow-hidden"
    }, header, expanded && /*#__PURE__*/ React.createElement("div", {
        className: "px-5 pb-5"
    }, children));
}
export function PentestIntakeForm(param) {
    var label = param.label, title = param.title, description = param.description, headerContent = param.headerContent, formId = param.formId, schema = param.schema, sections = param.sections, submitContent = param.submitContent, className = param.className, onSubmit = param.onSubmit, enableLines = param.enableLines, successContent = param.successContent, errorContent = param.errorContent, isSubmitting = param.isSubmitting;
    var allFields = sections.flatMap(function(s) {
        return s.fields;
    });
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", null, !!title && /*#__PURE__*/ React.createElement(SectionHeader, {
        label: label,
        title: title
    }), !!description && /*#__PURE__*/ React.createElement(Body, {
        variant: "default",
        className: "prose prose-md mt-5 mb-7 md:mb-10 max-w-3xl"
    }, description), !!headerContent && /*#__PURE__*/ React.createElement("div", {
        className: "max-w-3xl mb-7 md:mb-10"
    }, headerContent), /*#__PURE__*/ React.createElement("div", {
        className: "max-w-3xl"
    }, successContent ? /*#__PURE__*/ React.createElement("div", null, successContent) : /*#__PURE__*/ React.createElement(GenericForm, {
        id: formId,
        schema: schema,
        config: allFields,
        onSubmit: onSubmit,
        renderLayout: function(fieldGroups) {
            var fieldIndex = 0;
            return /*#__PURE__*/ React.createElement("div", {
                className: "grid grid-cols-1 gap-5"
            }, sections.map(function(section) {
                var sectionFieldCount = section.fields.length;
                var sectionFields = fieldGroups.slice(fieldIndex, fieldIndex + sectionFieldCount);
                fieldIndex += sectionFieldCount;
                return /*#__PURE__*/ React.createElement(CollapsibleSection, {
                    key: section.title,
                    title: section.title,
                    description: section.description,
                    collapsible: section.collapsible,
                    defaultExpanded: section.defaultExpanded
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "grid grid-cols-1 gap-5"
                }, sectionFields));
            }), !!errorContent && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ErrorMessage, null, errorContent)), /*#__PURE__*/ React.createElement("div", {
                className: "flex justify-end"
            }, /*#__PURE__*/ React.createElement(Button, {
                type: "submit",
                name: "submit",
                variant: "primary",
                disabled: isSubmitting,
                icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
            }, submitContent)));
        }
    }))));
}

//# sourceMappingURL=PentestIntakeForm.js.map